export default function(el) {

  let dataProvidedDateInput = el.closest('tr').find('.data-provided-date');
  if (typeof dataProvidedDateInput !== 'undefined') {
    let dataProvidedDateVal = dataProvidedDateInput.attr('data-current-date');
    dataProvidedDateInput.val(dataProvidedDateVal);
  }

  let dataProvidedByInput = el.closest('tr').find('.data-provided-by');
  if (typeof dataProvidedByInput !== 'undefined') {
    let dataProvidedByVal = dataProvidedByInput.attr('data-current-user');
    dataProvidedByInput.val(dataProvidedByVal);
  }

}